// extracted by mini-css-extract-plugin
export var contentBody = "_89-9";
export var headerImage = "_89-2";
export var imageButton = "_89-7";
export var imageButtonIcon = "_89-8";
export var imageHeader = "_89-4";
export var imageHeaderText = "_89-5";
export var imageOverlay = "_89-3";
export var imageTitle = "_89-6";
export var imageWrapper = "_89-1";
export var taskList = "_89-a";
export var widget = "_89-0";